module.exports = __webpack_public_path__ + "img/DSC01833.c6803c33.jpg";